export default "__VITE_ASSET__C5SWX5Gw__"